import React from 'react'
import { useSelector } from 'react-redux'
import moment from 'moment'
import { isEmpty, map } from 'lodash'

import CalendarDateCell from './CalendarDateCell'
import { dateKeyFormat } from '../../../configuration/calendar'
import getFilteredSchedule from '../../../utilities/events/getFilteredSchedule'
import EventEntry from './EventEntry'
import EventEntryPopover from './EventEntryPopover'

const CalendarDateCells = ({
  currentDate,
  openEventsPopover,
  closeEventsPopover,
  selectedDate,
}) => {
  const eventScheduleData = useSelector((state) => state.eventScheduleData)
  const activeCategories = useSelector((state) => state.filtersData.categories)
  const activeLocations = useSelector((state) => state.filtersData.locations)
  const monthStart = moment(currentDate).startOf('month')
  const monthEnd = moment(monthStart).endOf('month')
  const startDate = moment(monthStart).startOf('week')
  const endDate = moment(monthEnd).endOf('week')

  let eventSchedule = null
  if (eventScheduleData?.data) {
    eventSchedule =
      isEmpty(activeCategories) && isEmpty(activeLocations)
        ? eventScheduleData.data
        : getFilteredSchedule(
            eventScheduleData.data,
            activeCategories,
            activeLocations,
            moment(startDate),
            moment(endDate)
          )
  }

  let weekRows = []
  let dayCells = []
  let day = startDate

  while (day <= endDate) {
    for (let i = 0; i < 7; i++) {
      let renderCellEvents = []
      let renderPopoverEvents = []

      if (eventSchedule) {
        const dateKey = moment(day).format(dateKeyFormat)
        const currentEventSchedule = eventSchedule[dateKey]

        map(currentEventSchedule, (schedule) => {
          const { id, eventTime } = schedule
          const eventKey = id + '-' + dateKey + '-' + eventTime
          renderCellEvents.push(<EventEntry key={`event-entry-${eventKey}`} schedule={schedule} />)
          renderPopoverEvents.push(
            <EventEntryPopover key={`event-entry-popover-${eventKey}`} schedule={schedule} />
          )
        })
      }

      dayCells.push(
        <CalendarDateCell
          key={day + 'event-cell'}
          currentDate={currentDate}
          day={day}
          openEventsPopover={openEventsPopover}
          closeEventsPopover={closeEventsPopover}
          renderCellEvents={renderCellEvents}
          renderPopoverEvents={renderPopoverEvents}
          selectedDate={selectedDate}
        />
      )

      day = moment(day).add(1, 'day')
    }

    weekRows.push(
      <div key={day} className="u-calendar__date-row">
        {dayCells}
      </div>
    )

    dayCells = []
  }

  return <div className="u-calendar__date-cells">{weekRows}</div>
}

export default CalendarDateCells
